// PromptTemplates.js
import React from 'react';

function PromptTemplates({ savedPrompts, selectedTemplate, setSelectedTemplate, setPrompt, deletePrompt }) {
  return (
    <div className="mt-4">
      <h5 className="mb-3 fw-semibold">Saved Prompt Templates</h5>
      <div className="d-flex flex-wrap gap-3">
        {Object.entries(savedPrompts).map(([name, promptText], idx) => (
          <div
            key={idx}
            className={`position-relative d-flex align-items-center justify-content-center text-center fw-semibold template-box ${selectedTemplate === name ? 'active' : ''}`}
            onClick={() => {
              setSelectedTemplate(name);
              setPrompt(promptText);
            }}
            style={{
              width: '183px',
              height: '183px',
              cursor: 'pointer',
              border: selectedTemplate === name ? '2px solid #fd7e14' : '2px solid transparent',
              backgroundColor: selectedTemplate === name ? '2px solid #fd7e14' : 'white',
              fontSize: '1rem',
              borderRadius: '0.75rem',
              transition: 'all 0.2s ease-in-out',
              userSelect: 'none'
            }}
          >
            {name}
            {selectedTemplate === name && (
              <span
                className="position-absolute top-0 end-0 translate-middle badge bg-danger text-white"
                onClick={(e) => {
                  e.stopPropagation();
                  deletePrompt(name);
                }}
                style={{ cursor: 'pointer', fontSize: '1rem' }}
              >×</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PromptTemplates;
